import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { revertInvoice } from "../../api";

const useRevertModal = ({
  refetch,
  handleClose,
  selectedId,
  dispatch,
  updateConfig,
}) => {
  const Options = [
    { value: 1, label: "Estimate" },
    { value: 2, label: "Orders" },
  ];
  const initialValues = {
    revert: "",
  };
  const validation = Yup.object({
    revert: Yup.string().required("Select atleast revert"),
  });
  const getFieldError = (fieldName) => {
    if (formik.touched[fieldName] && formik.errors[fieldName]) {
      return formik.errors[fieldName];
    }
    return "";
  };
  const formik = useFormik({
    initialValues,
    validationSchema: validation,
    onSubmit: async (values) => {
      const params = {
        invoice_id: selectedId?.[0],
        type: values.revert,
      };
      revertInvoice(params).then((response) => {
        if (response?.data?.status_code === 200) {
          toast.success(
            response?.data?.message ??
              "Certificate added to recheck list successfully"
          );
          dispatch(
            updateConfig((state) => {
              state.invoiceHistoryFilter.revertState = true;
              state.clear = true;
            })
          );
          const timeOut = setTimeout(() => {
            dispatch(updateConfig((state) => (state.clear = false)));
            clearTimeout(timeOut);
          }, 1000);
          handleClose();
          refetch();
        } else {
          toast.error("Something went wrong");
          handleClose();
          refetch();
        }
      });
    },
  });
  return { Options, formik, getFieldError };
};
export default useRevertModal;
